import React from 'react';
import Sidebar from './Sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      backgroundColor: '#F8F9FA' // Tabby gray background
    }}>
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content Area */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: '#F8F9FA' // Ensure main area also has gray background
      }}>
        <main style={{
          flex: 1,
          overflow: 'auto',
          backgroundColor: '#F8F9FA' // Tabby page background
        }}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
